<template>
    <!-- -- default layout -- -->

    <!-- <Announcement /> -->
    <AppHeader />
    <main class="content-grid">
        <slot />
    </main>
    <AppFooter />
</template>
